import { render, staticRenderFns } from "./ModalChat.vue?vue&type=template&id=70a9e00c&scoped=true"
import script from "./ModalChat.vue?vue&type=script&lang=js"
export * from "./ModalChat.vue?vue&type=script&lang=js"
import style0 from "./ModalChat.vue?vue&type=style&index=0&id=70a9e00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9e00c",
  null
  
)

export default component.exports